<template>
    <div class="animated fadeIn profile-page" v-if="ready">
        <b-row>
            <!-- Left column: account + settings -->
            <b-col cols="12" lg="6" class="mb-4">
                <div class="profile-section">
                    <h5 class="section-title">{{ $t('account') }}</h5>
                    <b-form @submit.stop.prevent="save">
                        <InputField
                            name="name"
                            :label="$t('name')"
                            v-model="user.name"
                            @error="fieldError"
                            :rules="{ required: true, length: { min: 2 } }"
                        />

                        <InputField
                            type="email"
                            name="email"
                            :label="$t('email')"
                            v-model="user.email"
                            @error="fieldError"
                            :rules="{ required: true, length: { min: 5 } }"
                            :disabled="true"
                        />

                        <b-row>
                            <b-col md="6">
                                <InputField
                                    type="password"
                                    name="password"
                                    :label="$t('password')"
                                    v-model="password"
                                    @error="fieldError"
                                    :rules="{ required: false, length: { min: 5 } }"
                                />
                            </b-col>
                            <b-col md="6">
                                <InputField
                                    type="password"
                                    name="confirm_password"
                                    :label="$t('confirmPassword')"
                                    v-model="confirm_password"
                                    @error="fieldError"
                                    :rules="{ required: false, length: { min: 5 }, matchWith: password }"
                                />
                            </b-col>
                        </b-row>

                        <b-button type="submit" variant="success" block>{{ $t('save') }}</b-button>
                    </b-form>
                </div>

                <div class="profile-section mt-4">
                    <h5 class="section-title">{{ $t('settings.title') }}</h5>

                    <b-form-group :label="$t('platformLocale')">
                        <b-select :options="locales" v-model="locale" />
                    </b-form-group>

                    <SelectField
                        name="timezone"
                        :label="$t('timezone')"
                        :rules="{}"
                        :items="timezones"
                        v-model="settings.timezone"
                        :description="$t('allDatesTimeZone')"
                    />

                    <b-form-checkbox id="two_auth" name="two_auth" v-model="settings.two_auth" class="mt-2">
                        {{ $t('twoFactorAuth') }}
                    </b-form-checkbox>
                </div>

                <div class="profile-section mt-4">
                    <h5 class="section-title">{{ $t('referral') }}</h5>
                    <div class="referral-link">
                        {{ publicURL }}/register?ref={{ user.ref }}
                    </div>
                    <b-button
                        size="sm"
                        variant="outline-secondary"
                        class="mt-2"
                        @click="copyReferral"
                    >
                        <i class="fa fa-copy mr-1"></i>{{ $t('copy') }}
                    </b-button>
                </div>
            </b-col>

            <!-- Right column: billing info -->
            <b-col cols="12" lg="6" class="mb-4" v-if="$isAdmin()">
                <div class="profile-section">
                    <BillingInfo />
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import IdentityFields from '@/components/identityFields/IdentityFields'
import Input from "@/components/form/Input"
import Select from '@/components/form/Select'
import timezones from 'compact-timezone-list';
import BillingInfo from './BillingInfo';
import { Switch as cSwitch } from '@coreui/vue'

export default {
    name: "Profile",
    components: {
        InputField: Input,
        SelectField: Select,
        IdentityFields,
        cSwitch,
        BillingInfo
    },
    data: function () {
        return {
            errors: [],
            personBillingErrors: [],
            billingErrors: [],
            password: "",
            confirm_password: "",
            publicURL: this.$env.get('FRONT_URL'),
            locales: [
                {
                    text: "English (US)",
                    value: "en_US"
                },
                {
                    text: "Serbian",
                    value: "sr"
                }
            ]
        }
    },
    methods: {
        fieldError(error, errorBag) {
            let bag = errorBag || "errors"
            let errors = this[bag]

            let found = errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                errors.push(error)
            } else {
                errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors(errorBag) {
            let bag = errorBag || "errors"
            let errors = this[bag]

            return errors.find((i, e) => {
                return i.error
            })
        },

        copyReferral() {
            const link = `${this.publicURL}/register?ref=${this.user.ref}`
            navigator.clipboard.writeText(link).then(() => {
                this.$bvToast.toast(this.$t('copied'), {
                    variant: 'success',
                    title: this.$t('success'),
                    autoHideDelay: 2000
                })
            }).catch(() => {
                this.$bvToast.toast(this.$t('unexpectedError'), { variant: 'danger' })
            })
        },

        save(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$mainDialog.msgBoxOk(this.$t('fieldsNotValid'))

                return
            }

            if (this.password !== this.confirm_password) {
                this.$mainDialog.msgBoxOk(this.$t('passwordNotValid'))

                return
            }

            let model = {
                name: this.user.name,
                email: this.user.email,
                settings: this.settings,
                billing_address: this.billingAddress
            }

            if (this.password != "") {
                model["password"] = this.password
            }

            this.$http.post("/v1/user/profile/edit", model).then(resp => {

                this.$bvToast.toast("Profile updated", {
                    variant: 'success',
                    title: "Success"
                })

                this.password = ""
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$mainDialog.msgBoxOk(error.response.data.message)
            })
        },


    },
    computed: {
        user() {
            return this.$store.getters.getUser
        },
        ready() {
            return (this.user !== null)
        },
        settings() {
            return this.user.settings
        },
        billingAddress() {
            return this.settings.billing_address || {}
        },
        timezones() {
            return timezones.map(t => {
                return {
                    text: t.label,
                    value: t.tzCode
                }
            })
        },

        locale: {
            get() {
                return this.$store.getters.getLocale
            },

            set(locale) {
                let popup = this.$loadingPopup()
                this.$store.dispatch("updateUserConfig", { path: 'locale', data: { locale: locale } }).then(() => {
                    let currentLocale = this.$store.getters.getLocale
                    if (currentLocale == locale) {
                        return
                    }

                    this.$store.commit('SET_LOCALE', locale)
                    this.$root.$i18n.locale = locale
                    this.$store.commit('RELOAD_CONTAINER')
                }).catch(err => {
                    console.error("Error changing locale", err)

                    this.$bvToast.toast(this.$t('failedToChangeLanguageLocale'), {
                        title: this.$t('unexpectedError'),
                        variant: 'danger'
                    })
                }).finally(() => {
                    popup.hide()
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.profile-page {
    .profile-section {
        background: rgba(255,255,255,0.03);
        border: 1px solid rgba(255,255,255,0.08);
        border-radius: 8px;
        padding: 1.5rem;

        .section-title {
            font-size: 0.85rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            color: rgba(255,255,255,0.45);
            margin-bottom: 1.25rem;
            padding-bottom: 0.6rem;
            border-bottom: 1px solid rgba(255,255,255,0.08);
        }
    }

    .referral-link {
        font-family: monospace;
        font-size: 0.85rem;
        background: rgba(0,0,0,0.2);
        border: 1px solid rgba(255,255,255,0.1);
        border-radius: 4px;
        padding: 0.6rem 0.85rem;
        color: rgba(255,255,255,0.7);
        word-break: break-all;
    }
}
</style>
